<template>
  <div :class="$style.wrap">
    <slot />
  </div>
</template>

<style module lang="scss">
.wrap {
  display: grid;
  gap: 24px 12px;
  grid-template-columns: auto 1fr;

  @media (--sp) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  > section {
    display: grid;
    grid-column: span 2;
    grid-template-columns: subgrid;

    @media (--sp) {
      gap: 8px;
      grid-template-columns: none;
    }
  }
}
</style>
